<template>
  <div class="brand">
      <div class="container">
          <div class="brand__body">
              <h1 class="brand__title">404 Page Not Found</h1>
              <p class="brand__desc"></p>
              <div class="brand__controls">
                <router-link to="/" class="button button--rounded button--wshadow button--secondary">Back to Home</router-link>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'PageNotFound',
  head: {
    title: {
      inner: 'Error 404',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'Page Not Found'
      },
      {
        name: 'keywords',
        content: '404'
      },
      {
        property: 'og:title',
        content: '404 - Ad Operator'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/404'
      },
      {
        property: 'og:description',
        content: 'Page Not Found'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co/404',
        id: 'canonical'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/front/404.vue